import React, { Component } from "react";
import ExchangeService from "../../../Services/ExchangeService";
import ExchangeRateItem from "../../../Domain/ExchangeRateItem";
import ExchangeRateSearchParams from "./ExchangeRateSearchParams";
import TabOfDataTable from "../../../Elements/DataTable/TabOfDataTable";

export default class ExchangeRatePanel extends Component {
  static defaultProps = {
    CurrencyId: 1,
    Type: "Daily",
  };

  constructor(props) {
    super(props);

    this.state = {
      type: props.Type,
      searchItem: new ExchangeRateSearchParams(),
      currencyId: props.CurrencyId,
    };

    this.GetExchangeRate = this.GetExchangeRate.bind(this);
    this.startSearch = this.startSearch.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        searchItem: { ...this.state.searchItem },
        type: this.props.Type,
        currencyId: this.props.CurrencyId,
      });
    }
  }

  startSearch(searchItem) {
    this.setState({ searchItem, currencyId: this.props.CurrencyId });
  }

  async GetExchangeRate(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    searchItem.CurrencyId = this.state.currencyId;
    searchItem.DateTimeFrom = new Date(searchItem.DateTimeFrom).toJSON();
    searchItem.DateTimeTo = new Date(searchItem.DateTimeTo).toJSON();
    searchItem.Type = this.state.type;

    return ExchangeService.GetExchangeRate(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache);
  }

  render() {
    return (
      <TabOfDataTable
        type={ExchangeRateItem}
        serviceFunction={this.GetExchangeRate}
        convertDBItemsFunction={ExchangeService.ConvertDBCurrencyDetails}
        searchParamsType={ExchangeRateSearchParams}
        showSearchStrip={true}
        clickOnStartSearch={this.startSearch}
        searchItem={this.state.searchItem}
        orderBy={"UtctimeStamp"}
        orderDirection={"Desc"}
        errorCode="ERP71"
      />
    );
  }
}
